type PickerPillSource = {
    text?: string;
    data?: {
        Name?: string;
        name?: string;
        value?: string;
        firstName?: string;
        lastName?: string;
        picture?: string;
        Picture?: string;
    };
};

export const getPickerPillText = (elem: PickerPillSource | undefined): string => {
    if (!elem) {
        return '';
    }

    const fromText = elem.text?.trim();
    if (fromText) {
        return fromText;
    }

    const base = elem.data?.Name || elem.data?.name || elem.data?.value || elem.data?.firstName || '';
    const lastName = elem.data?.lastName;
    if (lastName && !String(base).includes(lastName)) {
        return `${base} ${lastName}`.trim();
    }

    return String(base).trim();
};

export const getPickerPillPicture = (elem: PickerPillSource | undefined): string | undefined => {
    return elem?.data?.picture || elem?.data?.Picture || undefined;
};
